import { of } from 'rxjs';
import { booleanOptions, eqOperator, fullComparator } from '../../filtre-investisseur-helper';
import { FiltreBuilder, ItemFiltreCustomBuilder } from '../filtre-builder.model';

export function getContratsBuilders(): FiltreBuilder[] {
  return [
    new ItemFiltreCustomBuilder(
      'CONTRATS_STELLIUM',
      'CONTRATS_STELLIUM_VP_MONTANT_MENSUEL',
      'investisseurVisionGlobale.montantTotalMensuelVp',
      fullComparator,
      'InputEuro',
      undefined,
      12
    ),
    new ItemFiltreCustomBuilder(
      'CONTRATS_STELLIUM',
      'CONTRATS_STELLIUM_VERSEMENTS_PROGRAMMES',
      'hasVersementsProgrammes',
      eqOperator,
      'Select',
      of(booleanOptions)
    ),
    new ItemFiltreCustomBuilder(
      'CONTRATS_STELLIUM',
      'CONTRATS_STELLIUM_MONTANT_INVESTI',
      'investisseurVisionGlobale.cumulVersementsNets',
      fullComparator,
      'InputEuro',
      undefined,
      12
    ),
    new ItemFiltreCustomBuilder(
      'CONTRATS_STELLIUM',
      'CONTRATS_STELLIUM_PERFORMANCE_FINANCIERE',
      'investisseurVisionGlobale.performanceGlobaleFinanciere',
      fullComparator,
      'InputPercent',
      undefined,
      3
    ),
    new ItemFiltreCustomBuilder(
      'CONTRATS_STELLIUM',
      'CONTRATS_STELLIUM_VALORISATION',
      'investisseurVisionGlobale.encoursTotal',
      fullComparator,
      'InputEuro',
      undefined,
      12
    ),
  ];
}
